export default {
  '校园风采':'校園風采',
  '分类':'分類',
  '是否启用':'是否啟用',
  '内容列表':'內容列表',
  '编辑名称':'編輯名稱',
  '确认要开启{title}吗？':'確認要開啟{title}嗎？',
  '确认要关闭{title}吗？':'確認要關閉{title}嗎？',
  '确认要停用吗？':'確認要停用嗎？',
  '确认要删除吗？':'確認要刪除嗎？',
  '内容':'內容',
  '标题':'標題',
  '支持jpg/jpeg/png格式，建议比例为1:1，最大不超过5M':'支持jpg/jpeg/png格式，建議比例為1:1，最大不超過5M',
}
